<template>
  <media-time-slider class="group relative inline-flex h-10 w-full touch-none select-none items-center outline-none aria-hidden:hidden">
    <media-slider-chapters class="relative flex h-full w-full cursor-pointer items-center rounded-[1px]">
      <template>
        <div
          class="last-child:mr-0 relative mr-0.5 flex h-full w-full items-center rounded-[1px]"
          style="contain: layout style"
        >
          <div
            class="relative z-0 h-2 w-full rounded-full bg-white/50 group-data-[focus]:ring"
            :style="{ backgroundColor: 'color-mix(in srgb, var(--media-color, currentColor) 50%, transparent)' }"
          >
            <div
              class="absolute h-full w-[var(--slider-fill)] rounded-full bg-white will-change-[width]"
              :style="{ backgroundColor: 'var(--media-color, currentColor)' }"
            />
          </div>
        </div>
      </template>
    </media-slider-chapters>

    <!-- Preview -->
    <media-slider-preview class="pointer-events-none flex flex-col items-center opacity-0 transition-opacity duration-200 data-[visible]:opacity-100">
      <div
        class="text-sm"
        data-part="chapter-title"
      />
      <media-slider-value
        class="rounded-md px-2 py-1 text-lg font-medium"
        :style="{ backgroundColor: 'var(--media-bg-color, white)' }"
      />
    </media-slider-preview>

    <!-- Thumb -->
    <div
      class="absolute left-[var(--slider-fill)] top-1/2 z-20 h-8 w-8 -translate-x-1/2 -translate-y-1/2 cursor-pointer rounded-full border-4 border-white bg-white will-change-[left] group-data-[dragging]:bg-white"
      :style="{ backgroundColor: 'var(--media-bg-color, white)', borderColor: 'var(--media-color, currentColor)' }"
    />
  </media-time-slider>
</template>